import { Link } from "react-router-dom";
import { Clapperboard, MapPin, MessageCircle } from "lucide-react";
import { BUSINESS, LEGAL_LINKS, waLink } from "@/lib/site";

export const PublicFooter = () => (
  <footer className="border-t border-slate-200 bg-white" data-testid="public-footer">
    <div className="mx-auto grid max-w-6xl gap-10 px-5 py-12 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-blue-600 text-white">
            <Clapperboard className="h-4 w-4" />
          </div>
          <div className="leading-tight">
            <p className="font-heading font-bold text-slate-900">{BUSINESS.name}</p>
            <p className="text-xs text-slate-500">{BUSINESS.tagline}</p>
          </div>
        </div>
        <div className="mt-4 flex items-start gap-2 text-sm text-slate-600" data-testid="footer-address">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-slate-400" />
          <span>{BUSINESS.address.line1}, {BUSINESS.address.line2}, {BUSINESS.address.line3}</span>
        </div>
        <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp"
          className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-blue-600 hover:underline">
          <MessageCircle className="h-4 w-4" /> WhatsApp Admin: {BUSINESS.whatsappDisplay}
        </a>
      </div>

      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">Informasi</p>
        <nav className="mt-4 flex flex-col gap-2 text-sm">
          {LEGAL_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="text-slate-600 hover:text-slate-900" data-testid={`footer-link-${l.to.replace("/", "")}`}>
              {l.label}
            </Link>
          ))}
        </nav>
      </div>

      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">Akun</p>
        <nav className="mt-4 flex flex-col gap-2 text-sm">
          <Link to="/masuk" className="text-slate-600 hover:text-slate-900" data-testid="footer-login">Masuk</Link>
          <Link to="/daftar" className="text-slate-600 hover:text-slate-900" data-testid="footer-register">Daftar</Link>
          <Link to="/#faq" className="text-slate-600 hover:text-slate-900" data-testid="footer-faq">FAQ</Link>
        </nav>
      </div>
    </div>
    <div className="border-t border-slate-100 py-5 text-center text-xs text-slate-400">
      © {new Date().getFullYear()} {BUSINESS.name}
    </div>
  </footer>
);
